import React from "react";
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux'
import SweetAlert from 'react-bootstrap-sweetalert';

import AccountContainer from './AccountContainer';
import EntityContainer from './EntityContainer';

import { getCurrentUser, logout } from '../../actions/session';
import { fetchInfo } from '../../actions/';
import {whereBallsMove} from "../../helper"

class Account extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            alertShow: false
        };

        this.showConfirm = this.showConfirm.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(
            fetchInfo([{ 
                query: 'settings-tax',
                params: {}
            }])
        );
    }

    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(6);
    }

    logout() {
        const { dispatch, history, session:{currentUser} } = this.props;

        dispatch(logout(
            currentUser,
            history,
            token => dispatch(getCurrentUser(token))
        ));
    }

    showConfirm(e) {
        e.preventDefault();
        
        this.setState({
            alertShow: true
        })
    }

    render() {
        return (
            <div className="vertical-scrolling page sixthSection sectionAccount" id="sectionAccount" data-main-nav-id="accountNavLink">

                {
                    this.state.alertShow ?
                    <SweetAlert
                        type="warning"
                        confirmBtnCssClass="alert-btn-confirm"
                        cancelBtnCssClass="alert-btn-cancel"
                        showCancel
                        confirmBtnText="Продолжить"
                        cancelBtnText="Отменить"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Вы уверены что хотите выйти из приложения"
                        onConfirm={this.logout.bind(this)}
                        onCancel={() => this.setState({alertShow: false})}
                    >
                    </SweetAlert>
                    : ''
                }       

                <div className="container content">
                    <Switch>
                        <Route path="/account/entity/:id?" component={EntityContainer} />
                        <Route
                            path="/account"
                            render={
                                props => 
                                <AccountContainer {...props}
                                    showConfirm={this.showConfirm}
                                    />
                            }
                            />
                    </Switch>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(Account);


// WEBPACK FOOTER //
// ./src/components/Account/index.js